'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'pipe';
var width = 64;
var height = 512;
var aliases = [];
var unicode = '7c';
var svgPathData = 'M32 0C45.3 0 56 10.7 56 24l0 464c0 13.3-10.7 24-24 24S8 501.3 8 488L8 24C8 10.7 18.7 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPipe = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;